import { ModalDialog, ModalMessage, ModalMessageColorsEnum } from '@acceso/design-system';
import { useTranslation } from 'react-i18next';

type BatchDeleteConfirmModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

export function BatchDeleteConfirmModal({
  isOpen,
  onClose,
  onConfirm,
}: BatchDeleteConfirmModalProps) {
  const { t } = useTranslation();
  return (
    <ModalDialog
      isOpen={isOpen}
      onClose={onClose}
      onAction={onConfirm}
      heading={t('Eliminar')}
      actionLabel={t('Eliminar')}
      linkLabel={t('Cancelar')}
      color={ModalMessageColorsEnum.ERROR}
    >
      <ModalMessage
        title={t('¿Estás seguro de que quieres eliminar todas las presencias seleccionadas?')}
      />
    </ModalDialog>
  );
}
